export default function AppFooter() {
  return (
    <footer
      data-testid="app-footer"
      className="w-full eis-header text-white mt-8"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div data-testid="footer-contact">
          <h3 className="text-lg md:text-xl font-bold mb-3">Contact</h3>
          <div className="text-sm md:text-base leading-relaxed space-y-1 text-white/95">
            <p>
              Eureka International School, Shree Control Chowk Road, Sinhagad
              Road, Dhayari, Pune, Maharashtra 411041
            </p>
            <p>+91 7276600034</p>
            <p>+91 9022955376</p>
            <p className="break-all">schooleurekainternational@gmail.com</p>
          </div>
        </div>
        <div className="md:text-right text-sm text-white/70 self-end">
          © {new Date().getFullYear()} Eureka International School. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
}
